import ScreenHeader from "../../components/ScreenHeader";
import { Button } from "react-bootstrap";
import { getListadoDeActasVencidas, getListadoExcel, listadoDeActasVencidasTableData } from "./handlers";
import { Table } from "../../components";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context";
import { useNavigate } from "react-router-dom";
import MuniSpinner from "../../components/MuniSpinner";

const ListadoDeActasVencidas = () => {
  const [listadoDeActasVencidas, setListadoDeActasVencidas] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { actions: ua } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (ua.hasRole("sudo")) {
      getListadoDeActasVencidas(setListadoDeActasVencidas, setIsLoading);
    } else {
      navigate("/");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <ScreenHeader screenHeaderTitle='Listado de Actas Vencidas' />
      <div>
        {isLoading && !listadoDeActasVencidas && <MuniSpinner />}

        {!isLoading && listadoDeActasVencidas && (
          <Table
            data={listadoDeActasVencidasTableData(listadoDeActasVencidas)}
            name='listado_de_actas_vencidas'
            render={() => {
              if (listadoDeActasVencidas.length > 0) {
                return (
                  <Button onClick={() => getListadoExcel()} className='btn btn-light d-flex gap-2 align-items-center my-auto me-1' style={{ maxHeight: "38px" }}>
                    <span style={{ color: "#111" }}>Descargar Listado</span>
                    <img src='https://webservice.muninqn.gov.ar/cglobales/assets/icons/Excel-Logo.png' alt='excel' style={{ height: 25 }} />
                  </Button>
                );
              }
            }}
          />
        )}

        {!isLoading && !listadoDeActasVencidas && <span>Sin actas vencidas</span>}
      </div>
    </div>
  );
};

export default ListadoDeActasVencidas;
